"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commentDefinition = void 0;
// we don't take comment updates into consideration.
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.commentDefinition = (0, firestore_1.defineCollection)({
    collectionName: "comment",
    idKey: "commentId",
    parent: project_1.projectDefinition,
    constraints: ["projectId", "segmentId", "scriptId"],
    queryDefs: {
        list: ({ projectId, segmentId, scriptId, }) => {
            return {
                constraint: { projectId },
                queryParams: {
                    filter: Object.assign({ scriptId }, (segmentId ? { segmentId } : {})),
                },
            };
        },
    },
    defaultValue: {
        commentId: "",
        projectId: "",
        segmentId: "",
        scriptId: "",
        comment: [],
        createdAt: 0,
        creatorEmail: "",
    },
    onAccess: (o) => o,
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
